import { Box, Label } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { Work } from '../../types'
import { getStatusLabel } from '../../utils/getStatusLabel'

export const WorkerStatus = ({
  status,
  minWidth = '200px',
}: {
  status: Work['status']
  minWidth?: string
}) => {
  const statusLabel = getStatusLabel(status)

  const config = useMemo(() => {
    switch (status) {
      case 'scheduled':
        return {
          label: statusLabel,
          color: 'neutral',
        }
      case 'started':
        return {
          label: statusLabel,
          color: 'information',
        }
      case 'rejected':
        return {
          label: statusLabel,
          color: 'none',
        }
      case 'bailed':
        return {
          label: statusLabel,
          color: 'error',
        }
      case 'approved':
        return {
          label: statusLabel,
          color: 'success',
        }
      case 'paid':
        return {
          label: statusLabel,
          color: 'success',
        }
      case 'removed':
        return {
          label: statusLabel,
          color: 'none',
        }
      case 'employer_approved':
        return {
          label: statusLabel,
          color: 'success',
        }
      case 'admin_review':
        return {
          label: statusLabel,
          color: 'error',
        }
      case 'employer_review':
        return {
          label: statusLabel,
          color: 'error',
        }
      case 'employer_cancelled':
        return {
          label: statusLabel,
          color: 'neutral',
        }
      case 'worker_declined_req':
        return {
          label: statusLabel,
          color: 'none',
        }
      case 'system_declined':
        return {
          label: statusLabel,
          color: 'neutral',
        }
      case 'completed':
        return {
          label: statusLabel,
          color: 'success',
        }
      default:
        return {
          label: statusLabel,
          color: 'none',
        }
    }
  }, [status])

  return (
    <Box as="span" minWidth={minWidth}>
      <Label variant={config.color} size="small">
        {config.label}
      </Label>
    </Box>
  )
}
